module.exports = __webpack_public_path__ + "static/media/Step1.59b9ed96.jpg";